import { useTranslation } from 'react-i18next';
import { EXTERNAL_URLS } from '../../constants';
import Modal from '../ui/Modal';

const LegalInfoModal = ({ open, onClose, legalText, consumerRightsLaw, showGeneralDirection }) => {
  const { t } = useTranslation(['layout']);

  return (
    <Modal open={open} onClose={onClose} title='Información Legal' maxWidth='lg'>
      <div className='flex flex-col gap-4 text-sm'>
        {legalText && (
          <div>
            <p className='text-gray-700 leading-relaxed'>{legalText}</p>
          </div>
        )}

        {consumerRightsLaw && (
          <div>
            <p className='text-gray-700 leading-relaxed'>
              <span className='font-semibold'>{consumerRightsLaw}. </span>
              {showGeneralDirection && (
                <>
                  <span>{t('footer.nationalAuthority', 'Autoridad Nacional de aplicación')}. </span>
                  <span>
                    {t(
                      'footer.consumerDefenseText',
                      'Defensa de las y los Consumidores. Para reclamos ingrese'
                    )}{' '}
                    <a
                      className='font-bold text-blue-600 hover:text-blue-800 hover:underline'
                      href={EXTERNAL_URLS.ARGENTINA_CONSUMER_DEFENSE}
                      rel='noreferrer'
                      target='_blank'
                    >
                      {t('footer.here', 'aquí')}.
                    </a>
                  </span>
                </>
              )}
            </p>
          </div>
        )}

        <div className='text-gray-700 leading-relaxed'>
          <p>
            En los contratos celebrados a distancia el Pasajero podrá ejercer su derecho de
            revocación dentro de los DIEZ (10) días corridos contados a partir de realizada la
            compra. (Resolución 954/2025). Los pasajes aéreos se rigen por la política de
            cancelación y condiciones tarifarias de la cía. aérea, informadas antes de la
            contratación (decreto 809/2024).
          </p>
        </div>
      </div>
      <Modal.Actions>
        <button
          onClick={onClose}
          className='px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors'
        >
          Cerrar
        </button>
      </Modal.Actions>
    </Modal>
  );
};

export default LegalInfoModal;

